import { colFormRef } from './consts';

export default function(editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const pfx = c.pfx;

  if (c.blocks.indexOf(colFormRef) >= 0) {
    bm.add(colFormRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="50">
    <path d="M22,5.5 C22,5.2 21.5,5 20.75,5 L3.25,5 C2.5,5 2,5.2 2,5.5 L2,8.5 C2,8.8 2.5,9 3.25,9 L20.75,9 C21.5,9 22,8.8 22,8.5 L22,5.5 Z M21,8 L3,8 L3,6 L21,6 L21,8 Z" fill-rule="nonzero"></path>
    <path d="M22,10.5 C22,10.2 21.5,10 20.75,10 L3.25,10 C2.5,10 2,10.2 2,10.5 L2,13.5 C2,13.8 2.5,14 3.25,14 L20.75,14 C21.5,14 22,13.8 22,13.5 L22,10.5 Z M21,13 L3,13 L3,11 L21,11 L21,13 Z" fill-rule="nonzero"></path>
    <rect x="2" y="15" width="10" height="3"/>
</svg>
      <div>${c.labelColForm}</div>`,
      category: c.labelColFormCategory,
      content: `
        <form class="${pfx}" data-js="add-remove-collection-form" data-gjs-type="add-remove-collection-form">
        <div class="form-container" draggable="false" data-gjs-copyable="false" data-gjs-selectable="false" data-gjs-custom-name="Form Container">
              <input data-gjs-type="input" draggable="true" data-highlightable="1" name="itemId" data-form-element-collection="uuid" type="hidden" class="form-control">
              <input data-gjs-type="input" draggable="true" data-highlightable="1" name="dataItemId" data-form-element-data-group="uuid" data-field-type="uuid" type="hidden" class="form-control">
              <div class="form-group no-border-bottom" data-gjs-copyable="false" data-gjs-selectable="false">
                <button type="submit" class="btn btn-sm btn-primary">Submit</button>
              </div>
          </div>
        </div>
        </form>
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="https://academy.drapcode.com/docs/app-builder/forms-component-collection-form" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        c.labelColForm
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
